import React, {PropTypes} from 'react';
import DateTimeFormatter from '../DateTimeFormatter';

const EventDeadlines = ({details}) => {
  // const savingsExist = NumberFormatter.scrubFormatting(savings.monthly) > 0;
  // const savingsClass = savingsExist ? 'savings' : 'loss';
  // const resultLabel = savingsExist ? 'Savings' : 'Loss';

  return (
    <div className="event-deadlines">
      <DateTimeFormatter
        value={details.first_registration_deadline}
        title="Påmeldingsfrist: "
        hide={false} />
      <DateTimeFormatter
        value={details.second_registration_deadline}
        title="Endringsfrist: "
        hide={true} />
      <DateTimeFormatter
        value={details.third_registration_deadline}
        title="Endringsfrist (krever godkjenning fra arrangør): "
        hide={true} />
      <DateTimeFormatter
        value={details.final_registration_deadline}
        title="Siste frist for endringer: "
        hide={true} />
    </div>
  );
};

// Note that this odd style is utilized for propType validation for now. Must be defined *after*
// the component is defined, which is why it's separate and down here.
EventDeadlines.propTypes = {
  details: PropTypes.object.isRequired,
};

export default EventDeadlines;



/** WEBPACK FOOTER **
 ** ./src/components/event/EventDeadlines.js
 **/